export default Object.freeze({
  AIRSHIP: 'airships',
  SUBMARINE: 'submarines',
});
